import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import css from './index.module.scss';
import { useEffect } from 'react';

const G: React.FC = () => {
    const { t } = useLang('dpux');
    useEffect(() => {
        if (typeof window !== 'undefined') {
            const sceneGArr: any[] = [];

            const label = document.querySelector('.delta-pro-ultra-x-G .info .label-ani');
            const title = document.querySelector('.delta-pro-ultra-x-G .info .title-ani');
            const desc = document.querySelector('.delta-pro-ultra-x-G .info .desc-ani');
            sceneGArr.push(
                AniContainer.create({
                    triggerElement: '.delta-pro-ultra-x-G .info',
                    triggerHook: 1,
                    offset: '20%',
                    duration: '100%',
                    onEnter: () => {
                        label.classList.add('enter');
                        title.classList.add('enter');
                        desc.classList.add('enter');
                    },
                    onProcess: (process: number) => {
                        if (process <= 0) {
                            label.classList.remove('enter');
                            title.classList.remove('enter');
                            desc.classList.remove('enter');
                        }
                    },
                }),
            );
            return () => {
                sceneGArr.forEach((item) => item.destroy());
            };
        }
    }, []);

    return (
        <section
            className={`${css.section} delta-pro-ultra-x-G GtmModuleData-section`}
            id="delta-pro-ultra-x-G"
            data-section-id={'delta-pro-ultra-x-G'}
            data-section-title={t('G_title')}
        >
            <EcoImg
                pc="https://websiteoss.ecoflow.com/upload/image/1760088008777/pc_High.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1760088008968/m_High.jpg"
                isOpenLazy={true}
            />
            <div className="info">
                <div className="box">
                    <div className="label-ani ani-1">
                        <p className={`label `}>{t('G_label')}</p>
                    </div>
                    <div className="title-ani ani-2">
                        <p className={`title`}>{t('G_title')}</p>
                    </div>
                </div>
                <div className="desc-ani ani-3">
                    <p className={`desc `}>
                        {t.rich('G_desc', {
                            h: (v: string) => <span className="h">{v}</span>,
                        })}
                    </p>
                </div>
            </div>
        </section>
    );
};

export default G;
